import { Outlet } from 'react-router-dom';
import { useBowserParser } from '@hooks/useBowserParser';
import { useWorkflow } from '@hooks/useWorkflow';

export const BrowserConfigParser = () => {
  const bowser = useBowserParser();
  const workflow = useWorkflow();
  const loading = bowser.loading || workflow.loading;

  const data = {
    workflow,
    bowser,
    loading,
  };

  return <Outlet context={data} />;
};
